<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-01
      	描述：插件中心-轮播图-列表
      -->
  <div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addCarousel">添加轮播图</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="carousel_id" label="轮播图ID"></el-table-column>
        <el-table-column prop="address" label="封面" >
          <template slot-scope="scope">
            <img v-img-url="'image.file_path',scope.row" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="category.name" label="轮播图分类" ></el-table-column>
        <el-table-column prop="sort" label="轮播图排序" ></el-table-column>
        <el-table-column prop="create_time" label="添加时间"></el-table-column>
        <el-table-column prop="update_time" label="更新时间"></el-table-column>
        <el-table-column prop="name" label="操作">
          <template slot-scope="scope">
            <el-button @click="editCarousel(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteCarousel(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CarouselApi from '@/api/carousel.js';
export default {
  components: {},
  data() {
    return {
      /*分类*/
      categoryData: [],
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    /*获取轮播图列表*/
    this.getTableList();
  },
  methods: {

    /*获取轮播图列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      CarouselApi.CarouselList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加轮播图*/
    addCarousel() {
      this.$router.push({
        path: '/plus/carousel/carousel/Add'
      });
    },

    /*编辑轮播图*/
    editCarousel(row) {
      let params = row.carousel_id;
      this.$router.push({
        path: '/plus/carousel/carousel/Edit',
        query: {
          carousel_id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*删除轮播图*/
    deleteCarousel(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          CarouselApi.deleteCarousel(
            {
              carousel_id: row.carousel_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    handleClick(tab, event) {},

    /*打开分类添加*/
    addCategory() {
      this.open_add = true;
    },

    /*打开分类编辑*/
    editCategory(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/carousel/carousel/Index.vue